import React from "react";
import { Link } from "react-router-dom";

// Shared split-screen shell for all auth pages.
export function AuthShell({ title, subtitle, children, footer, image = "https://images.unsplash.com/photo-1638202993928-7267aad84c31?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" }) {
  return (
    <div className="flex min-h-screen bg-white">
      <div className="hidden w-1/2 lg:block">
        <div className="relative h-full">
          <img src={image} alt="" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-slate-900/55" />
          <div className="absolute inset-0 flex flex-col justify-between p-10 text-white">
            <Link to="/" className="flex items-center gap-2.5">
              <img src="/icon-192.png" alt="FHAPAS" className="h-10 w-10 rounded-lg bg-white p-0.5" />
              <span className="font-display text-xl font-extrabold">FHAPAS</span>
            </Link>
            <div>
              <p className="font-display text-3xl font-bold leading-tight">Fendana Hospital &amp; Patient Administration System</p>
              <p className="mt-3 max-w-md text-white/80">Clinical-grade operations for hospitals, laboratories and imaging centres.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex w-full items-center justify-center px-5 py-10 lg:w-1/2">
        <div className="w-full max-w-md">
          <Link to="/" className="mb-8 flex items-center gap-2.5 lg:hidden">
            <img src="/icon-192.png" alt="FHAPAS" className="h-9 w-9 rounded-lg" />
            <span className="font-display text-lg font-extrabold text-slate-900">FHAPAS</span>
          </Link>
          <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-slate-500">{subtitle}</p>}
          <div className="mt-7">{children}</div>
          {footer && <div className="mt-6 text-center text-sm text-slate-500">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
